/**
 * This function is used to parse JSON strings.
 * If the parsing fails, it will just return the passed variable which can be any primitive type.
 * * Can be be refactored to check if its a valid json string before parsing it into try catch block.
 * @param {unknown} variable - The variable to parse. It can be of any type.
 * @returns {Object | unknown} The parsed object if the variable is a valid JSON string, or the original variable if it's not.
 */
export default function parseJson(variable: unknown) {
  // when `variable` is a number-like string (like `"100"`), this function returns a number (100)
  // `if` below makes this behavior consistent for the case when `variable` is `"0"`, so that function will return 0 (number)
  // (otherwise, function will return `"0"` (string) when `variable` is `"0"`)
  if (variable === '0') {
    return 0;
  }
  try {
    const parsedStr = JSON.parse(`${variable}`);
    if (parsedStr) {
      return parsedStr;
    }
    return variable;
  } catch {
    return variable;
  }
}
